<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="(e) => (checkedRows = e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <el-badge
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
          v-if="allow('G')"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="generatePurchase()"
            :disabled="!checkedRowCount"
          >
            {{ $l('btn_generatePurchase') || '生成工厂采购单' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <GeneratePurchase
      :visible.sync="generatePurchaseOpts.visible"
      :params="generatePurchaseOpts.params"
      @reload="reload"
    />
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header'
import GeneratePurchase from '../generate-purchase'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, GeneratePurchase },
  data() {
    return {
      checkedRows: [],
      usePage: true,
      generatePurchaseOpts: { visible: false, params: {} },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    async getData(form) {
      this.loading = true
      const res = await this.$api
        .ecomAmzFlipOrderSkuScmSummaryListApi({ ...form, ...this.page })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
      this.clearCheckboxRow()
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
    generatePurchase() {
      if (!this.checkedRowCount) return
      const listKey = this.checkedRows.map(
        (item) => `${item.amzFlipOrderCode}${item.scmCode}`
      )
      this.generatePurchaseOpts = {
        visible: true,
        params: { listKey },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
